import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { history } from 'routes/history';

import { SelfEmployed } from 'components/accountType/SelfEmployed/SelfEmployed';
import { Employed } from 'components/accountType/Employed/Employed';
const Rentier = require('components/accountType/rentier').rentier;
const Pensioner = require('components/accountType/pensioner').pensioner;
const WithoutActivity = require('components/accountType/withoutActivity').withoutActivity;
import accountTypeActions from 'actions/accountTypeActions';
import preLoaderActions from 'actions/preLoaderActions';
import { actions } from 'react-redux-form';
import { formatText } from 'core/i18n';
import { errorTag } from 'utilities/uTagging';
import { PATH_PROFESSION } from 'constants/uTagConstants/paths';
import { ERROR_CASO_EMPLEADO } from 'constants/analyticsErrors';
import {
    EMPLOYED_ID,
    PENSIONER_ID,
    RENTIER_ID,
    SELF_EMPLOYED_ID,
    WITHOUT_ACTIVITY_ID,
} from 'utilities/professionHelper';
import { BASE_PATH } from 'constants/index';
import { TRADITIONAL, ROBO } from 'constants/userProfile';
import WithFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';
import { FIOC_TGSS } from 'constants/featureFlagging';
import { JOINT_HOLDER_AUTORIZED } from 'constants/identityMethod';

class AccountType extends React.Component {
    state = {
        loading: true,
    };

    componentDidMount = () => {
        this.setLoading(false);
    };

    UNSAFE_componentWillReceiveProps = nextProps => {
        const { userProfile, accountTypeActions, disabled } = this.props;
        const setLoading = this.setLoading;

        if (!disabled) {
            const accessToken = userProfile.accessToken;
            const showPreLoader = this.props.preLoaderActions.showPreLoader;
            const hidePreLoader = this.props.preLoaderActions.hidePreLoader;
            setLoading(true);

            if (nextProps.typeId !== this.props.typeId && accessToken) {
                showPreLoader();
                switch (nextProps.typeId) {
                    case '01': //Self Employed
                        accountTypeActions.saveSelfEmployedInformation({}, accessToken, (saved, errors) => {
                            if (!saved) {
                                if (errors['6002']) {
                                    history.push(`${BASE_PATH}/errors`);
                                }
                            }
                            setLoading(false);
                            hidePreLoader();
                        });
                        break;
                    case '02': //Employed
                        accountTypeActions.saveEmployedInformation({}, accessToken, (saved, error) => {
                            if (!saved) {
                                errorTag(error.body, PATH_PROFESSION, ERROR_CASO_EMPLEADO, error.statusCode);
                            }
                            setLoading(false);
                            hidePreLoader();
                        });
                        break;
                    case '03': //Rentier
                        accountTypeActions.saveRentierInformation({}, accessToken, (saved, errors) => {
                            if (!saved) {
                                if (errors['6002']) {
                                    history.push(`${BASE_PATH}/errors`);
                                }
                            }
                            setLoading(false);
                            hidePreLoader();
                        });
                        break;
                    case '04': //Pensioner
                        accountTypeActions.savePensionerInformation({}, accessToken, (saved, errors) => {
                            if (!saved) {
                                if (errors['6002']) {
                                    history.push(`${BASE_PATH}/errors`);
                                }
                            }
                            setLoading(false);
                            hidePreLoader();
                        });
                        break;
                    case '05': //No declared activity
                        accountTypeActions.saveUnemployedInformation({}, accessToken, (saved, errors) => {
                            if (!saved) {
                                if (errors['6002']) {
                                    history.push(`${BASE_PATH}/errors`);
                                }
                            }
                            setLoading(false);
                            hidePreLoader();
                        });
                        break;
                    default:
                        break;
                }
            } else {
                setLoading(false);
            }
        } else {
            setLoading(false);
        }
    };

    setLoading = loading => {
        this.setState({
            loading,
        });
    };

    buildCommonList = () => {
        this.commonList = {
            selfActivity: [
                {
                    label: 'No desarrollo actividad en ninguno de los sectores aquí nombrados',
                    value: 'noneOfTheAbove',
                },
                {
                    label: 'Fabricación, distribución y/o intermediación en el comercio de armas y otros productos militares',
                    value: 'militaryProducts',
                },
                {
                    label: 'Servicios de pago o de cambios de moneda: transmisores de dinero, casas de cambio o sus respectivos agentes',
                    value: 'paymentsOrCurrencyExchange',
                },
                {
                    label: 'Casinos o entidades de apuestas debidamente autorizadas',
                    value: 'casinosOrBettingEntities',
                },
                {
                    label: 'Importación o exportación de material y equipos de telefonía',
                    value: 'importExportTelecommunications',
                },
                {
                    label: 'Importación o exportación de automóviles',
                    value: 'importExportAutomobile',
                },
                {
                    label: 'Importación o exportación de material informático o electrónico',
                    value: 'importExportElectronic',
                },
                {
                    label: 'Comercio de joyas, piedras o metales preciosos',
                    value: 'jewelryPreciousStonesAndMetals',
                },
                {
                    label: 'Compraventa de automóviles de ocasión',
                    value: 'usedCarsDealer',
                },
                {
                    label: 'Reciclado de metales',
                    value: 'recyclingMaterials',
                },
                {
                    label: 'Actividad que lleva implícito manejo de importantes sumas de efectivo',
                    value: 'cashHandling',
                },
                {
                    label: 'Marchante o anticuario',
                    value: 'worksOfArtOrAntiques',
                },
            ],
            annualIncome: [
                {
                    label: formatText('field-annualIncomeYes'),
                    value: true,
                },
                {
                    label: formatText('field-annualIncomeNo'),
                    value: false,
                },
            ],
            annualIncomeAmount: [
                {
                    label: '< 15.000€',
                    value: 109,
                },
                {
                    label: '15.000€ - 22.000€',
                    value: 110,
                },
                {
                    label: '22.000€ - 35.000€',
                    value: 111,
                },
                {
                    label: '35.000€ - 55.000€',
                    value: 112,
                },
                {
                    label: '55.000€ - 90.000€',
                    value: 113,
                },
                {
                    label: '90.000€ - 120.000€',
                    value: 114,
                },
                {
                    label: '120.000€ - 150.000€',
                    value: 115,
                },
                {
                    label: '> 150.000€',
                    value: 116,
                },
            ],
            monthlyQuestions: [
                { value: 1, label: 'Si' },
                { value: 2, label: 'No' },
            ],
            otherActivities: [
                {
                    label: formatText('field-otherActivities_item_1'),
                    value: 'X300B',
                },
                {
                    label: formatText('field-otherActivities_item_2'),
                    value: 'X200A',
                },
                {
                    label: formatText('field-otherActivities_item_3'),
                    value: 'X300A',
                },
            ],
        };
    };

    shouldRenderTgssQuestion = () => {
        const { userProfile, flags } = this.props;
        const isTraditionalUser = userProfile.investmentType === TRADITIONAL;
        const isRoboUser = userProfile.investmentType === ROBO;
        const featureFlag = flags.get(FIOC_TGSS);

        return (
            (isTraditionalUser || isRoboUser) &&
            featureFlag &&
            !userProfile.isAlreadyClient &&
            userProfile.jointHolderType !== JOINT_HOLDER_AUTORIZED
        );
    };

    buildView = typeAccount => {
        this.buildCommonList();

        if (!this.state.loading) {
            switch (typeAccount) {
                case SELF_EMPLOYED_ID: //Self Employed
                    return (
                        <SelfEmployed
                            {...this.props}
                            commonList={this.commonList}
                            shouldRenderTgssQuestion={this.shouldRenderTgssQuestion()}
                        />
                    );
                case EMPLOYED_ID: //Employed
                    return (
                        <Employed
                            {...this.props}
                            commonList={this.commonList}
                            shouldRenderTgssQuestion={this.shouldRenderTgssQuestion()}
                        />
                    );
                case RENTIER_ID: //Rentier
                    return (
                        <Rentier
                            {...this.props}
                            commonList={this.commonList}
                            shouldRenderTgssQuestion={this.shouldRenderTgssQuestion()}
                        />
                    );
                case PENSIONER_ID: //Pensioner
                    return (
                        <Pensioner
                            {...this.props}
                            commonList={this.commonList}
                            shouldRenderTgssQuestion={this.shouldRenderTgssQuestion()}
                        />
                    );
                case WITHOUT_ACTIVITY_ID: //No declared activity
                    return (
                        <WithoutActivity
                            {...this.props}
                            commonList={this.commonList}
                            shouldRenderTgssQuestion={this.shouldRenderTgssQuestion()}
                        />
                    );
                default:
                    break;
            }
        }
    };

    render = () => {
        const typeAccount = this.props.typeId ? this.props.typeId : '';

        return <div>{this.buildView(typeAccount)}</div>;
    };
}

module.exports.constructor = AccountType;
module.exports.AccountType = connect(
    state => ({
        userProfile: state.userProfile,
    }),
    dispatch => ({
        accountTypeActions: bindActionCreators(accountTypeActions, dispatch),
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
        formActions: bindActionCreators(actions, dispatch),
    })
)(WithFeatureToggling(AccountType));
